import { z } from 'zod';
import { BaseEventSchema } from '../Base';

export const CartEventSchema = BaseEventSchema.extend({
  access: z.string().optional(),
  products: z.number(),
});

export enum CartInteractionEventTypes {
  CartOpen = 'interaction.cart.open',
  CartClose = 'interaction.cart.close',
  CartStartPayment = 'interaction.cart.got_to_checkout',
}

export const CartInteractionEventTrackingSchemas = {
  [CartInteractionEventTypes.CartOpen]: CartEventSchema,
  [CartInteractionEventTypes.CartClose]: CartEventSchema,
  [CartInteractionEventTypes.CartStartPayment]: BaseEventSchema,
};
